import AppLink from './AppLink.vue'

// Globally registered components, applied by configureApp in both mount
// paths. Keep this list short — only components used across many features.
export default {
  install(app) {
    app.component('AppLink', AppLink)
  }
}
